import React from "react";

const CartSummarySkeleton = () => {
  return (
    <>
      {/* Cart Header Skeleton */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#ffff",
          padding: "20px",
          borderRadius: "10px 10px 0 0",
        }}
      >
        <div
          style={{
            height: "20px",
            width: "80px",
            backgroundColor: "rgba(0,0,0,0.1)",
            borderRadius: "4px",
          }}
        />
        <div
          style={{
            height: "20px",
            width: "120px",
            backgroundColor: "rgba(0,0,0,0.1)",
            borderRadius: "4px",
          }}
        />
      </div>

      {/* Cart Content Skeleton */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "15px 20px",
          marginBottom: "10px",
          borderRadius: "0 0 10px 10px",
        }}
      >
        <div
          style={{
            height: "18px",
            width: "90%",
            backgroundColor: "rgba(0,0,0,0.1)",
            borderRadius: "4px",
            marginBottom: "10px",
          }}
        />
        <div
          style={{
            height: "14px",
            width: "100px",
            backgroundColor: "rgba(0,0,0,0.1)",
            borderRadius: "4px",
            marginBottom: "8px",
          }}
        />
        <div
          style={{
            width: "100%",
            height: "8px",
            backgroundColor: "#e0e0e0",
            borderRadius: "4px",
          }}
        />
      </div>
    </>
  );
};
export default CartSummarySkeleton;
